import React, { useEffect, useState, useRef } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import useWindowSize from '../../../hooks/useWindowSize';

import { isEmpty, keys, pickBy } from 'lodash';
import { bob, k2aCore } from '../../../data/tabs';

import queryString from 'query-string';

import { array } from 'prop-types';

import { Grid, GridNoRecords, GridColumn as Column } from '@progress/kendo-react-grid';
import { process as kendoProcess } from '@progress/kendo-data-query';
import BobLoadingMask from '../../../components/BobLoadingMask';
import BobModal from '../../../components/BobModal';
import CreateEquipmentOrSystemModal from '../EquipmentPage/CreateEquipmentOrSystemModal';
import DeleteSystemModal from '../SystemPage/DeleteSystemModal';
import BobTableContextMenu from '../../../components/BobTableContextMenu';
import CreateSubscriptionModal from '../Modals/CreateSubscriptionModal';

import { dashboardContent } from '../../../localization/en-us/dashboardContent';
import {calculateMinColumnWidths} from '../../../helpers/calculateMinColumnWidths';

import * as BobActions from '../../../actions/bobActions';
import * as DashboardActions from '../../../actions/dashboardActions';
import { kendoGridInlineStyling } from '../../../helpers/kendoGridInlineStyleHelper';
import classes from './Table.module.css';

const initialDataState = {
    sort: [],
    take: 10,
    skip: 0
};

const SystemsTable = ({
    activeNavCompany,
    activeNavClient,
    activeNavSite,
    bobLoading,
    companies,
    createEquipmentModalOpen,
    dashboardEndTimeStamp,
    dashboardStartTimeStamp,
    deleteSystemModalOpen,
    fetchDashboardData,
    fetchKpiData,
    fetchNavClients,
    fetchSingleSite,
    history,
    handleToggleCreateEquipmentModal,
    handleToggleDeleteSystemModal,
    handleToggleSubscribeToSystemsAlertsModal,
    isFromSystemTab,
    resetNavOptions,
    refreshTab,
    setRefreshTab,
    setNavCompany,
    setTableProps,
    searchTerm,
    siteSystems,
    siteSystemsMeta,
    subscribeToAlertsSystemsModalOpen,
    systemFilters,
    targetNavCompany,
    totalsData,
    workbookModeEnabled,
    ...props
}) => {
    const [sortFilter] = useState('');
    const [typeFilters, setTypeFilters] = useState([]);
    const [priorityFilters, setPriorityFilters] = useState([]);
    const [skip, setSkip] = useState(0);
    const [take, setTake] = useState(10);
    const [pageable] = useState({ pageSizes: true });
    const [systemData, setSystemData] = useState(null);
    const [dataState, setDataState] = useState(initialDataState);
    const [systemColumnWidth, setSystemColumnWidth] = useState(250);

    const queryValues = queryString.parse(history.location.search);
    const companyId = queryValues.company;
    const clientId = queryValues.client;
    const siteId = queryValues.site;

    const isInitialMount = useRef(true);
    const gridDivRef = useRef(null);
    const gridRef = useRef(null);

    const windowSize = useWindowSize();

    useEffect(() => {
        const columns = gridRef.current.props.children;
        setSystemColumnWidth(calculateMinColumnWidths(columns, gridDivRef.current.offsetWidth, 'systemName', 250, true));
    }, [windowSize]);

    useEffect(() => {
        if (!workbookModeEnabled) {
            initialDataState.take = take;
            setDataState(initialDataState);
        }
    }, [workbookModeEnabled]);

    useEffect(() => {
        setSkip(0);
        setTake(10);
    }, [siteId]);

    useEffect(() => {
        const columns = gridRef.current.props.children;
        setSystemColumnWidth(calculateMinColumnWidths(columns, gridDivRef.current.offsetWidth, 'systemName', 250, true));
        if (systemFilters.type || Object.values(systemFilters.priority).includes(true)) {
            const typeFilters = systemFilters.type.map(filter => filter.id);
            const priorityFilters = keys(pickBy(systemFilters.priority));

            setTypeFilters(typeFilters);
            setPriorityFilters(priorityFilters);
        }
    }, []);

    useEffect(() => {
        if (activeNavSite && activeNavSite.name && isEmpty(siteSystems)) {
            initializeFetch();
        }
    }, [activeNavSite]);

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;
        } else {
            if (systemFilters.type || Object.values(systemFilters.priority).includes(true)) {
                if (!isEmpty(targetNavCompany) && !isEmpty(siteSystemsMeta)) {
                    initializeFetch();
                }
            } else {
                const init = async () => {
                    initializeFetch();
                };
                
                if (activeNavCompany.id && !isEmpty(siteSystems)) init();
            }
        }
    }, [systemFilters, dashboardStartTimeStamp, dashboardEndTimeStamp, searchTerm]);

    useEffect(() => {
        const refresh = async () => {
            let page = 1;

            if ( skip && take ) {
                page = skip / take + 1;
            }

            let promises = [];

            promises.push(fetchKpiData(activeNavCompany.id, 'SiteSystem', activeNavSite.id, dashboardStartTimeStamp, dashboardEndTimeStamp));
        
            if (sortFilter) {
                promises.push(fetchDashboardData(activeNavCompany.id, 'SiteSystem', { clientId: activeNavClient.id, siteId: activeNavSite.id, sort: sortFilter, searchFilter: searchTerm, page: page, limit: take, startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp }, typeFilters, priorityFilters));
            } else {
                promises.push(fetchDashboardData(activeNavCompany.id, 'SiteSystem', { clientId: activeNavClient.id, siteId: activeNavSite.id, sort: 'default^desc', searchFilter: searchTerm, page: page, limit: take, startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp }, typeFilters, priorityFilters));
            }
            
            await Promise.all(promises.map(p => p.catch(err => err)));
            setRefreshTab();
        };

        if (refreshTab) refresh();
    }, [refreshTab]);

    const initializeFetch = async () => {
        setSkip(0);

        const typeFilters = systemFilters.type.map(filter => filter.id);
        const priorityFilters = keys(pickBy(systemFilters.priority));

        setTypeFilters(typeFilters);
        setPriorityFilters(priorityFilters);

        let promises = [];

        setTableProps({
            search: searchTerm,
            sort:   sortFilter
        });

        promises.push(fetchKpiData(activeNavCompany.id, 'SiteSystem', activeNavSite.id, dashboardStartTimeStamp, dashboardEndTimeStamp));
        
        if (sortFilter) {
            promises.push(fetchDashboardData(activeNavCompany.id, 'SiteSystem', { clientId: activeNavClient.id, siteId: activeNavSite.id, sort: sortFilter, limit: take, searchFilter: searchTerm, startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp }, typeFilters, priorityFilters));
        } else {
            promises.push(fetchDashboardData(activeNavCompany.id, 'SiteSystem', { clientId: activeNavClient.id, siteId: activeNavSite.id, sort: 'default^desc', limit: take, searchFilter: searchTerm, startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp }, typeFilters, priorityFilters));
        }

        await Promise.all(promises.map(p => p.catch(err => err)));
    };

    const fetchSystemListAfterCreate = async searchTerm => {
        setSkip(0);

        await fetchDashboardData(activeNavCompany.id, 'SiteSystem', { clientId: activeNavClient.id, siteId: activeNavSite.id, sort: 'default^desc', searchFilter: '', limit: take, startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp }, typeFilters, priorityFilters);
    };

    const renderNavUrl = dataItem => {
        const queryValues = queryString.parse(history.location.search);

        return `system?client=${dataItem.clientId}&company=${queryValues.company}&site=${dataItem.siteId}&system=${dataItem.systemId}`;
    };

    const renderScoreNavUrl = dataItem => {
        const queryValues = queryString.parse(history.location.search);

        return `system?client=${dataItem.clientId}&company=${queryValues.company}&site=${dataItem.siteId}&system=${dataItem.systemId}&viewChildId=4b25aeb8-45d4-4522-9f77-870ab40abb07`;
    };

    const handleNav = async dataItem => {
        let path = '/v2/dashboard/system';

        const queryValues = queryString.parse(history.location.search);
        queryValues.client = dataItem.clientId;
        queryValues.site = dataItem.siteId;
        queryValues.system = dataItem.systemId;

        if (targetNavCompany.id !== dataItem.companyId) {
            resetNavOptions('all');
            const company = companies.find(item => item.company.id === dataItem.companyId);
            setNavCompany({
                name: company.company.name,
                id:   company.company.id
            });
            fetchNavClients(dataItem.companyId);
        } else {
            resetNavOptions('site');
        }

        const queryValuesString = queryString.stringify(queryValues);

        history.push(`${path}?${queryValuesString}`);

        await fetchSingleSite(queryValues);
    };

    const nameCell = props => {
        return (
            <td>
                <Link
                    to={renderNavUrl(props.dataItem)}
                    onClick={
                        (e) => {
                            if (!e.ctrlKey) {
                                handleNav(props.dataItem);
                            }
                        }
                    }
                >
                    {props.dataItem[props.field]}
                </Link>
            </td>
        );
    };

    const priorityCell = props => {
        let imgPath = '/assets/images/low.svg';
        if (props.field === 'mediumFaultCount') {
            imgPath = '/assets/images/medium.svg';
        } else if (props.field === 'highFaultCount') {
            imgPath = '/assets/images/high.svg';
        }
        return (
            <td>
                <img className={ props.dataItem[props.field] > 0 ? classes.IconImage: classes.IconImageGray} src={imgPath} alt="" />
                {props.dataItem[props.field]}
            </td>
        );
    };

    const scoresCell = props => {
        let value = props.dataItem[props.field];
        value = value.toString().includes('.') ? parseFloat(value).toFixed(2) : value;

        return (
            <td>
                <Link
                    to={renderScoreNavUrl(props.dataItem)}
                    onClick={
                        (e) => {
                            if (!e.ctrlKey) {
                                handleNav(props.dataItem);
                            }
                        }
                    }
                >
                    {value + '%'}
                </Link>
            </td>
        );
    };

    const fetchDashboardSystems = async searchTerm => {
        setSkip(0);

        await fetchDashboardData(companyId, 'SiteSystem', { clientId, siteId, sort: 'default^desc', searchFilter: '', limit: take, startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp }, typeFilters, priorityFilters);
    };

    const handleEditSystem = systemData => {
        setSystemData(systemData);
        process.env.k2aCoreEnabled ?
            history.push({
                pathname: `/v2/dashboard/core/entities/manage`,
                search:   `appId=${k2aCore.key}&childId=d0f113f5-32e1-4e2c-bf4d-386edb7f9bc4&client=${activeNavClient.id}&company=${activeNavCompany.id}&entityId=${systemData.systemId}&entityType=system&parentId=33ba6af0-1e7a-4fcf-b75b-f355a01a962b&site=${activeNavSite.id}`,
                state:    { 'returnUrl': `/v2/dashboard/site?appId=${bob.key}&childId=13dfff21-071c-4ee6-ab53-903fdcb5996a&client=${activeNavClient.id}&company=${activeNavCompany.id}&parentId=c0c505f5-c7fc-4317-8cb6-f6e631142a77&site=${activeNavSite.id}` }
            })
            :
            handleToggleCreateEquipmentModal(true);
    };

    const fetchSystemDataForDelete = (systemData) => {
        setSystemData(systemData);
        handleToggleDeleteSystemModal(true);
    };

    const subscribeSystemData = (systemData) => {
        systemData.name = systemData.systemName;
        systemData.id = systemData.systemId;

        setSystemData(systemData);
        handleToggleSubscribeToSystemsAlertsModal(true);
    };

    const actionsCell = props => {
        return (
            <td className={props.className} style={props.style}>
                <BobTableContextMenu
                    entityData={props.dataItem}
                    onSubscribeAlerts={(entityData) => { subscribeSystemData(entityData); }}
                    onDelete={(entityData) => fetchSystemDataForDelete(entityData)}
                    onFetch={(entityData) => handleEditSystem(entityData)}
                />
            </td>
        );
    };

    const onDataStateChange = e => {
        setTake(e.dataState.take);
        setDataState(e.dataState);
    };

    const actionFilterCell = props => {
        return (
            <div />
        );
    };

    return (
        <React.Fragment>
            <style>
                { kendoGridInlineStyling }
            </style>
            <div ref={gridDivRef} className={classes.Table}>
                <Grid
                    ref={gridRef}
                    sortable={{
                        mode: 'multiple'
                    }}
                    className={classes.KendoGrid}
                    data={kendoProcess(siteSystems, dataState)}
                    {...dataState}
                    pageable={pageable}
                    onDataStateChange={onDataStateChange}
                    reorderable={true}
                    filterable={workbookModeEnabled}
                >
                    {
                        bobLoading.includes('SiteSystem') || isEmpty(siteSystemsMeta) ?
                            <GridNoRecords>
                                Loading systems
                            </GridNoRecords>
                            :
                            null
                    }
                    <Column
                        field="systemName"
                        title={dashboardContent.system}
                        cell={nameCell}
                        id="systemColumn"
                        width={systemColumnWidth}
                    />
                    <Column field="systemTypeName" title={dashboardContent.systemType} width={175} />
                    <Column
                        field="equipmentCount"
                        title={dashboardContent.equipment}
                        width={175}
                        filter="numeric"
                    />
                    <Column
                        field="sensorCount"
                        title={dashboardContent.sensors}
                        width={175}
                        filter="numeric"
                    />
                    <Column
                        field="systemScore"
                        title={dashboardContent.score}
                        width={175}
                        cell={scoresCell}
                        filter="numeric"
                    />
                    <Column
                        field="totalFaultCount"
                        title={dashboardContent.faults}
                        width={175}
                        filter="numeric"
                    />
                    <Column
                        field="highFaultCount"
                        title={dashboardContent.high}
                        width={175}
                        cell={priorityCell}
                        filter="numeric"
                    />
                    <Column
                        field="mediumFaultCount"
                        title={dashboardContent.medium}
                        width={175}
                        cell={priorityCell}
                        filter="numeric"
                    />
                    <Column
                        field="lowFaultCount"
                        title={dashboardContent.low}
                        width={175}
                        cell={priorityCell}
                        filter="numeric"
                    />
                    <Column
                        field=""
                        title=""
                        width={75}
                        cell={actionsCell}
                        locked={true}
                        sortable={false}
                        filterable={false}
                        filterCell={actionFilterCell}
                    />
                </Grid>
                {
                    subscribeToAlertsSystemsModalOpen ?
                        <CreateSubscriptionModal
                            parent={systemData}
                            parentLabel="System"
                            handleToggleSubscribeToAlertsModal={handleToggleSubscribeToSystemsAlertsModal}
                        />
                        :
                        null
                }
                {
                    createEquipmentModalOpen ?
                        <BobModal
                            title={systemData ? 'Edit System' : 'Add New System'}
                            hidebuttons={true}
                            isRemoveFooter={true}
                            onClose={() => {
                                setSystemData(null);
                                handleToggleCreateEquipmentModal(false);}}
                        >
                            <CreateEquipmentOrSystemModal
                                system={systemData}
                                isEdit={systemData ? true : false}
                                isFromSystemTab={isFromSystemTab}
                                fetchSystemListAfterCreate={(name) => fetchSystemListAfterCreate(name)}
                                onClose={() => {
                                    setSystemData(null);
                                    handleToggleCreateEquipmentModal(false);}}
                            />
                        </BobModal> : ''
                }
                {
                    deleteSystemModalOpen ?
                        <BobModal
                            title={'Delete Entity'}
                            hidebuttons={true}
                            isRemoveFooter={true}
                            onClose={() => {
                                handleToggleDeleteSystemModal(false);
                                setSystemData(null);}}
                        >
                            <DeleteSystemModal
                                system={systemData}
                                fetchDashboardSystems={fetchDashboardSystems}
                                onClose={() => {
                                    handleToggleDeleteSystemModal(false);
                                    setSystemData(null);}}
                            />
                        </BobModal> : ''
                }
                {
                    bobLoading.includes('SiteSystem') || isEmpty(siteSystemsMeta) ?
                        <BobLoadingMask
                            className={classes.Loader}
                        />
                        :
                        null
                }
            </div>
        </React.Fragment>
    );
};

SystemsTable.defaultProps = {
    siteSystems: []
};

SystemsTable.propTypes = {
    siteSystems: array
};

const mapStateToProps = state => ({
    activeNavClient:         state.bob.activeNavClient,
    activeNavCompany:        state.bob.activeNavCompany,
    activeNavSite:           state.bob.activeNavSite,
    bobLoading:              state.bob.bobLoading,
    companies:               state.core.companies,
    dashboardEndTimeStamp:   state.dashboard.dashboardEndTimeStamp ? state.dashboard.dashboardEndTimeStamp.format() : null,
    dashboardStartTimeStamp: state.dashboard.dashboardStartTimeStamp ? state.dashboard.dashboardStartTimeStamp.format() : null,
    siteSystems:             state.dashboard.siteSystems,
    siteSystemsMeta:         state.dashboard.siteSystemsMeta,
    systemFilters:           state.dashboard.systemFilters,
    targetNavCompany:        state.bob.targetNavCompany
});

const mapDispatchToProps = ({
    ...BobActions,
    ...DashboardActions
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SystemsTable));
